/**
 * Máscaras para CPF e CNPJ (inclui nova regra alfanumérica do CNPJ 2026).
 *
 * CPF: 000.000.000-00 (11 dígitos)
 * CNPJ numérico: 00.000.000/0000-00 (14 dígitos)
 * CNPJ alfanumérico (2026): 00.000.000/0000-00 com letras nos 12 primeiros (ex: 12.ABC.345/01DE-35)
 * DV sempre numérico (2 últimos).
 */

import { CNPJ_TAMANHO } from "../../domain/validators/terceiros.constantes.js";
import { sanitizarCpfCnpj } from "../../domain/rules/normalizadores.js";

export { sanitizarCpfCnpj };

/**
 * Sanitiza CPF/CNPJ: maiúsculas, só A-Z0-9.
 * @param {*} valor
 * @returns {string}
 */
/**
 * Sanitiza CPF/CNPJ para máscara (bloqueia além do limite 14).
 * @param {*} valor
 * @returns {string}
 */
export function sanitizarCpfCnpjParaMascara(valor) {
  return sanitizarCpfCnpj(valor).slice(0, CNPJ_TAMANHO);
}

/**
 * Aplica máscara incremental CPF/CNPJ.
 * Detecta CNPJ se contém letra ou length > 11, senão CPF.
 * @param {*} valor
 * @returns {string}
 */
export function aplicarMascaraCpfCnpj(valor) {
  const raw = sanitizarCpfCnpjParaMascara(valor);
  if (!raw) return "";

  const isCnpj = /[A-Z]/.test(raw) || raw.length > 11;

  if (isCnpj) {
    // CNPJ: 00.000.000/0000-00
    if (raw.length <= 2) return raw;
    if (raw.length <= 5) return `${raw.slice(0, 2)}.${raw.slice(2)}`;
    if (raw.length <= 8) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5)}`;
    if (raw.length <= 12) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8)}`;
    return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12)}`;
  }

  // CPF: 000.000.000-00
  if (raw.length <= 3) return raw;
  if (raw.length <= 6) return `${raw.slice(0, 3)}.${raw.slice(3)}`;
  if (raw.length <= 9) return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6)}`;
  return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6, 9)}-${raw.slice(9, 11)}`;
}

/**
 * Remove máscara, retorna só alfanumérico upper.
 * @param {*} valor
 * @returns {string}
 */
export function removerMascaraCpfCnpj(valor) {
  return sanitizarCpfCnpj(valor);
}
